export const ACTIONS = [
	'pageView',
	'hashChange',
	'userState',
	'customerInfo',
	'pageViewDetails',
	'addToCart',
	'removeFromCart',
	'addToWishlist',
	'removeFromWishlist',
	'login',
	'register',
	'subscribeNewsletter',
	'unsubscribeNewsletter',
	'refundRequest',
	'promotionClick',
	'productImpressions',
	'productClick',
	'checkoutStepView',
	'checkoutStepCompleted',
	'checkoutSetEmail',
	'checkoutSetShippingType',
	'checkoutSetShippingMethod',
	'checkoutSetPaymentMethod',
	'checkoutPurchase',
	'coreWebVitals',
	'createQuote',
	'inlineSearch',
	'menuItemClick',
	'afterCheckoutSuccess',
	'livstickAdded',
	'livstickRemoved',
	'livstickVideoSubmitted',
	'clickMenuImage',
]
